import { render } from "./page-select.vue?vue&type=template&id=4bbcf97a&scoped=true"
import script from "./page-select.vue?vue&type=script&lang=js"
export * from "./page-select.vue?vue&type=script&lang=js"

import "./page-select.vue?vue&type=style&index=0&id=4bbcf97a&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-4bbcf97a"

export default script